export default __webpack_public_path__ + "static/media/martin_mb.42440f3e.jpg";